/*
 * @Author: wujiawei 3055034214@qq.com
 * @Date: 2024-03-13 14:22:10
 * @LastEditors: ztong 183658589@qq.com
 * @LastEditTime: 2025-12-11 11:00:06
 * @FilePath: \data_tool\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* jshint -W024 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'

//公共模块路由
const SharingRouter = [{
  path: "*",
  redirect: "/404"
},
{
  path: '/404',
  name: '/404',
  component: () =>
    import('@/views/404.vue')
},
{
  path: '/401',
  name: '/401',
  component: () =>
    import('@/views/401.vue')
},
{
  // 首页
  path: '/',
  name: '/',
  component: () =>
    import('@/views/home/index.vue')
},
{
  // 首页
  path: '/index2',
  name: 'index2',
  component: () =>
    import('@/views/home/index2.vue')
},
{
  // 登录
  path: '/login',
  name: 'login',
  component: () =>
    import('@/views/login/index.vue')
},
{
  // python工具
  path: '/python-tool',
  name: 'python-tool',
  component: () =>
    import('@/views/python-tool/index.vue')
}
];


// 解决路由地址重复点击的报错问题
const originalPush = Router.prototype.push;
// const originalReplace = Router.prototype.replace;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// Router.prototype.replace = function push(location) {
//    return originalReplace.call(this, location).catch(err => err)
// }

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [...SharingRouter],
})

router.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(sessionStorage.getItem('UserInfo'));

  if (!userInfo && to.path !== '/login' && to.path !== '/Regist') { // 用户id 不存在的时候跳转到登录
      // 跳转到登录页面时携带参数
      next({
        path: '/login',
        query: to.query
      });
      return;
  }
  if (sessionStorage.getItem('AccessToken')) { // 通过vuex state获取当前的token是否存在
      if(to.path=='/examList'||to.path=='/user/examCase'){
          if(userInfo.type==6){
              next();
              return;
          }else{
              next('/new_index');
              return;
          }
      }else{
          next();
          return;
      }
  } else {
    next();
  }
})

// router.beforeEach((to, from, next){

// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js